var render, staticRenderFns
import script from "./attr_panel.vue?vue&type=script&lang=js"
export * from "./attr_panel.vue?vue&type=script&lang=js"
import style0 from "./attr_panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports